import Vue from 'vue'
import {join} from 'ramda'

Vue.filter('join', function (value) {
  return join(', ', value)
})
